/* --------------------
    Event Handler
-------------------- */
$(document).on("load", initScrollMagic);


$(document).ready(function () {
    initScrollMagic();
});


/* --------------------
    Functions
-------------------- */
function initScrollMagic() {
    if ($('#trigger')[0]) {
        var controller = new ScrollMagic.Controller();

        new ScrollMagic.Scene({
            triggerElement: "#trigger",
            triggerHook: "0",
            duration: true
        })
            .setClassToggle(("#navigation", "--scrolled"))
            .on("enter", function (e) {
                $('#navigation').addClass('--scrolled');
            })
            .on("leave", function (e) {
                $('#navigation').removeClass('--scrolled');
            })
            // .addIndicators()
            .addTo(controller);
    } else {
        $('#navigation').addClass('--sticky');
    }
}
